/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 18:25:21
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:14:27
 * @name: 注册对象
 * @Description: 注册对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\login\register.class.js
 * @Author: DESKTOP-1QU67QM
 */
const register = class register {
    constructor() {
        this.telephone = ''; //手机号
        this.verificationCode = ''; //验证码
        this.name = ''; //组织名称
        this.province = ''; //所在地 省份
        this.city = ''; //所在地 城市
        this.type = ''; //行业类型选中
        this.typeList = []; //行业类型数组
        this.password = ''; //登录密码
        this.realname = ''; //联系人姓名
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取行列类型数组
     */
    async getTypeList() {
        this.typeList = [
            {
                id: 1,
                name: '私营企业',
            },
            {
                id: 2,
                name: '公有企业',
            },
            {
                id: 3,
                name: '个人',
            },
        ]
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 提交申请
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    async submit() {
        return Promise.resolve();
    }
}

export default register;
